import React from 'react';
import { CrawlHealthView } from './CrawlHealthView';

export interface CrawlHealthRouteProps {
  className?: string;
}

const CrawlHealthRoute: React.FC<CrawlHealthRouteProps> = ({ className = '' }) => {
  return (
    <div className={className}>
      <CrawlHealthView />
    </div>
  );
};

export default CrawlHealthRoute;
